import { useRender } from "../../context/renderContext";
import { useIssuesData } from "../../hooks/useIssues";
import IssueDonutCard from "../ui/IssueDonutCard";
const colors = ["#64b5f6", "#ff8a65", "#aed581", "#ffd54f", "#4db6ac", "#ba68c8"];
const PeopleDealingIssues = () => {
  const { selectedOption, setSelectedOption, options } = useRender();
  const { issuesData } = useIssuesData();
  const handleChange = (event) => {
    setSelectedOption?.(event.target.value);
  };
  const prepareChartData = (overallData) => {
   const overallCounts = overallData?.[0];
   if (!overallCounts) return [];
    return Object.entries(overallCounts).map(([label, value], index) => ({
      id: index,
      value,
      color: colors[index % colors.length],
      label
    }));
  };
  const chartData = issuesData ? prepareChartData(issuesData?.overall) : [];
  return <IssueDonutCard
    title="Concerns People are dealing with"
    count={issuesData?.overallCount || 0}
    caption="Total users dealing with issues"
    chartData={chartData}
    chartTitle="Issues"
    accent="teal"
    dropdown={{ value: selectedOption, onChange: handleChange, options }}
  />;
};
var PeopleDealingIssues_default = PeopleDealingIssues;
export {
  PeopleDealingIssues_default as default
};